import React from "react";

export interface IconCircleChevronDownProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconCircleChevronDown: React.FC<IconCircleChevronDownProps> = ({
  width = 32,
  height = 32,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 3.19922C8.92995 3.19922 3.19995 8.92922 3.19995 15.9992C3.19995 23.0692 8.92995 28.7992 16 28.7992C23.07 28.7992 28.7999 23.0692 28.7999 15.9992C28.7999 8.92922 23.07 3.19922 16 3.19922ZM9.94995 15.2492C9.47995 14.7792 9.47995 14.0192 9.94995 13.5542C10.42 13.0892 11.18 13.0842 11.6449 13.5542L15.995 17.9042L20.3449 13.5542C20.8149 13.0842 21.5749 13.0842 22.0399 13.5542C22.5049 14.0242 22.5099 14.7842 22.0399 15.2492L16.85 20.4492C16.38 20.9192 15.62 20.9192 15.155 20.4492L9.94995 15.2492Z"
      fill={fill}
    />
  </svg>
);
